export default __webpack_public_path__ + "static/media/093-diagonal-arrow-6.4d9d91e1.png";